import { Typography } from '@euler/app/components/typography';
import { usePresentationTheme } from '@euler/app/tv/theme';
import { HStack } from '@euler/components/layout/Stack';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { memo, ReactNode } from 'react';
import { StyleProp, TextStyle, View, ViewStyle } from 'react-native';

export const Panel = memo(
  ({
    title,
    beforeTitle,
    style,
    headerStyle,
    titleStyle,
    contentContainerStyle,
    headerRight,
    children,
  }: {
    title?: string;
    beforeTitle?: ReactNode;
    headerStyle?: StyleProp<ViewStyle>;
    titleStyle?: StyleProp<TextStyle>;
    contentContainerStyle?: StyleProp<ViewStyle>;
    style?: StyleProp<ViewStyle>;
    children?: ReactNode;
    headerRight?: ReactNode;
  }) => {
    const theme = usePresentationTheme();
    const { rpx } = useResponsiveContext();
    return (
      <View
        css={`
          background-color: ${theme.panel.bg};
          border-radius: ${rpx(20)}px;
          overflow: hidden;
        `}
        style={style}
      >
        {title ? (
          <View
            css={`
              margin-left: ${rpx(32)}px;
              margin-top: ${rpx(32)}px;
              flex-direction: row;
              align-items: center;
              justify-content: space-between;
            `}
            style={headerStyle}
          >
            <HStack>
              {beforeTitle}
              <Typography.Label
                bold
                color={theme.panel.titleTextColor}
                size={rpx(32)}
                style={titleStyle}
              >
                {title}
              </Typography.Label>
            </HStack>
            {headerRight != null ? (
              <View
                css={`
                  margin-right: ${rpx(32)}px;
                `}
              >
                {headerRight}
              </View>
            ) : null}
          </View>
        ) : null}
        <View
          css={`
            padding-top: ${rpx(16)}px;
            padding-left: ${rpx(32)}px;
            padding-bottom: ${rpx(32)}px;
            padding-right: ${rpx(32)}px;
          `}
          style={contentContainerStyle}
        >
          {children}
        </View>
      </View>
    );
  },
);
